import {get as getSectors} from 'components/api';
import {sectorsByCourse} from '../../../constants/url';

function getsectorFromCourse(idCourse: number, role: string, token: string) {
  const url = `${sectorsByCourse}?id_course=${idCourse}&role=${role}`;
  return getSectors(url, token);
}

export default getsectorFromCourse;
